import { render, staticRenderFns } from "./widget.vue?vue&type=template&id=b9a44ecc&scoped=true&"
import script from "./widget-main.js?vue&type=script&lang=js&"
export * from "./widget-main.js?vue&type=script&lang=js&"
import style0 from "./widget.css?vue&type=style&index=0&id=b9a44ecc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a44ecc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
